var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":_vm.text}},on),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-network-strength-4-alert")]),_vm._v(" "+_vm._s(_vm.$t('offline-button.no-connection'))+" ")],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('offline-button.internet-connection-not-active')))])])}
var staticRenderFns = []

export { render, staticRenderFns }